import { formatDistanceToNow } from "date-fns";
import { fr } from "date-fns/locale";

function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function stringAvatar(name: string) {
  return {
    sx: { width: 80, height: 80, mr: 2, bgcolor: stringToColor(name) },
    children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
  };
}

function formatDate(date: Date) {
  return "Il y a " + formatDistanceToNow(date, { locale: fr });
}

export { stringToColor, stringAvatar, formatDate };
